import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "auth" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: "https://www.payo.com.au/wp-content/uploads/2021/06/Frame.png" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", null, "Connect your Lightspeed POS", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " Connect your Lightspeed POS to start taking payments with Payo Checkout. ", -1)
const _hoisted_6 = { class: "form-wrapper" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "btn btn-success",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.auth && _ctx.auth(...args))),
          disabled: _ctx.disabled
        }, " Get Started ", 8, _hoisted_7)
      ])
    ])
  ]))
}